import type { SlotAwareField } from '@cli-types/core-engine/schema-reader.js'
import { walkHeight } from './walk-height.js'

export function collectInvalidHeightErrors(
  topLevelFields: SlotAwareField[],
  rootPath: string,
  errors: string[]
): void {
  const prefix = rootPath ? `${rootPath}.` : ''
  for (const field of topLevelFields) {
    walkHeight(field, `${prefix}${field.name ?? 'unnamed'}`, errors)
  }
}
